// @flow

export const contextStubFunction = (name: string) => () => {
  throw new Error(
    `${name}Context function was called outside of a provider scope. Are you missing a <${name}Context.Provider>?`,
  );
};
